import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-50/80">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-xl"></i>
              </div>
              <span className="text-xl font-bold text-background-50">久久视频</span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/60">
              聚合香蕉视频、红桃视频、91视频等热门平台资源，免费在线看最新电影、热播电视剧、美剧韩剧全集。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">视频分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作平台</h4>
            <ul className="space-y-2">
              <li><span className="text-sm text-background-50/60">香蕉视频</span></li>
              <li><span className="text-sm text-background-50/60">红桃视频</span></li>
              <li><span className="text-sm text-background-50/60">91视频</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 久久视频 Jiujiu.Video - 本站内容均来自网络共享资源，仅供交流学习之用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}